import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CatalogDtosKeysEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-dtos-keys.enum';
import { CatalogCheckersEnum } from '@zaoblako/shared/modules/catalog/enums/catalog-checkers.enum';
import { SecurityBackendValidatorsEnum } from '@zaoblako/shared/modules/security/enums/security-backend-validators.enum';
import { hexColorSchema } from '@zaoblako/shared/modules/serde/schemas/hex-color.schema';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import type { DirectionFindInterface } from '@zaoblako/shared/modules/catalog/dtos/direction/direction-find.dto';
import type { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';
import type { UserGroupFindInterface } from '@zaoblako/shared/modules/security/dtos/user-group/user-group-find.dto';

import * as yup from 'yup';

/** Direction group create and update requests body */
export interface DirectionGroupFormInterface {
  /** Display name */
  name: string;
  /** Special code of this direction for Atrium CRM (using by some reports) */
  atriumCode?: string;
  /** Direction color (using by some reports) */
  color?: string;
  /** Parent direction */
  parent?: DirectionFindInterface;
  /** Generatl direction (for plans) */
  generalDirection?: DirectionFindInterface;
  /** Users whose has access to direction in budget requests */
  users?: UserFindInterface[];
  /** User groups that have access to this direction */
  userGroups?: UserGroupFindInterface[];
}

/** Direction group create and update requests body - DTO schema */
export const DirectionGroupFormDto = SerdeDtoClass.create<DirectionGroupFormInterface>(CatalogDtosKeysEnum.DIRECTION_GROUP_FORM_DTO, {
  name: {
    label: 'Название',
    serializer: yup.string(),
  },
  atriumCode: {
    label: 'Код для "Атриума"',
    optional: true,
    serializer: yup.string(),
  },
  color: {
    optional: true,
    label: 'Цвет',
    serializer: hexColorSchema,
  },
  parent: {
    label: 'Группа',
    optional: true,
    serializer: entityLikeSchema,
    checkers: [
      CatalogCheckersEnum.DIRECTION_ASSERT_EXISTS_BY_DTO,
      CatalogCheckersEnum.CHECK_PARENT_DIRECTION_BY_DTO,
    ],
  },
  generalDirection: {
    label: 'Рассчетная БС',
    optional: true,
    serializer: entityLikeSchema,
    checkers: [
      CatalogCheckersEnum.DIRECTION_ASSERT_EXISTS_BY_DTO,
      CatalogCheckersEnum.CHECK_GENERAL_DIRECTION_CIRCULAR_DEPENDENCY_BY_DTO,
    ],
  },
  users: {
    label: 'Пользователи',
    optional: true,
    checkers: [SecurityBackendValidatorsEnum.USER_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(entityLikeSchema),
  },
  userGroups: {
    label: 'Группы пользователей',
    optional: true,
    checkers: [SecurityBackendValidatorsEnum.USER_GROUP_ASSERT_EXISTS_BY_DTO],
    serializer: yup.array(entityLikeSchema),
  },
});
